import './App.css';
import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import cs from "./components/style.module.css";
import Main from './components/Main.jsx';
import Insert from './components/Insert.jsx';
import UpdateHendrick from './components/Update.jsx';
import Error404 from './components/Error404.jsx';
import Login from './components/Login.jsx';
import Consolidated from './components/Consolidated.jsx';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

useEffect(() => {
// Check if the user is already logged in based on credentials stored in localStorage
const token = localStorage.getItem('token');
setIsLoggedIn(!!token); // Update the logged-in state based on the presence of the token
}, []);

const handleLogin = (token) => {
setIsLoggedIn(true);
localStorage.setItem('token', token); // Store the token in localStorage
};

const handleLogout = () => {
setIsLoggedIn(false);
localStorage.removeItem('token'); // Remove the token from localStorage on logout
};
  let AllRoutes = createBrowserRouter(
    [
      { path: '/',  element: <Main /> },
      { path: '/insert/:title', element: <Insert isLoggedIn={isLoggedIn} /> },
      { path: '/update/:title/:id', element: <UpdateHendrick isLoggedIn={isLoggedIn} /> },
      { path: '*', element: <Error404 /> },
      { path: '/login', element: <Login onLogin={handleLogin} /> },
      
    ]
  )
  return (
    <div className={`App ${cs.bgMain}`}>
      <React.StrictMode>
        <RouterProvider router={AllRoutes} />
      </React.StrictMode>
    </div>
  );
}

export default App;
